import { SurveyKey } from '../../commonv3/types/surveys';
import { MainV3ApiBase } from './base';
import { SurveyIndexView } from '../types/surveys';

export const SurveyApis = {
  show(key: SurveyKey): Promise<SurveyIndexView> {
    return MainV3ApiBase.appendPath('surveys').withId(key).get();
  },
};
